import { Component, Input } from '@angular/core';

import { IllustrationPageLayoutComponent } from '../illustration-page-layout/illustration-page-layout.component';

@Component({
  selector: 'auth-page-layout',
  templateUrl: './auth-page-layout.component.html'
})
export class AuthPageLayoutComponent extends IllustrationPageLayoutComponent {
  @Input() cardTitle: string;
  @Input() illustration: string;
  @Input() isSignedIn: string;
}
